import { loadIdentity } from "./identity";
import { signedPost } from "./signedRequest";

function responseMessage(error) {
  const payload = error?.response?.data;
  if (typeof payload === "string") return payload;
  if (Array.isArray(payload?.message)) return payload.message.join(" ");
  return payload?.message || payload?.detail || error?.message || "Errore sconosciuto";
}

/**
 * Diffondere un post è una normale azione sociale. Non deve mai aprire il
 * recupero del profilo, richiedere le 12 parole o tentare di ricreare le
 * chiavi. L'autenticazione è gestita dalla sessione pubblica già attiva.
 */
export function requiresIdentityRecovery() {
  return false;
}

export function diffusionErrorMessage(error) {
  const status = error?.response?.status;
  const message = responseMessage(error);

  if (error?.code === "PUBLIC_SESSION_EXPIRED" || status === 401) {
    return "Sessione scaduta o non valida. Esci dal profilo e accedi di nuovo.";
  }
  if (/impossibile sbloccare la chiave privata|chiave locale|12 parole/i.test(message)) {
    return "Sessione non disponibile. Riapri il profilo e riprova.";
  }
  if (status === 404) {
    return `Diffondi non disponibile (404): ${message}. Il messaggio potrebbe non esistere più.`;
  }
  if (status === 429) {
    return "Troppe richieste ravvicinate. Riprova tra alcuni secondi.";
  }
  if (status === 502 || status === 503) {
    return "Servizio temporaneamente non disponibile. Riprova tra poco.";
  }
  if (status) return `Diffondi non riuscito (${status}): ${message}`;
  return `Diffondi non riuscito: ${message}`;
}

/**
 * Mantiene il nome storico della funzione per compatibilità con il componente
 * del feed, ma non esegue più alcuna riparazione o secondo tentativo.
 */
export async function diffusePostWithRepair(postId) {
  const identity = loadIdentity();
  if (!identity?.identityId) {
    throw new Error("Sessione utente non disponibile");
  }

  const path = `/api/v1/posts/${encodeURIComponent(postId)}/diffuse`;
  const response = await signedPost(path, { identityId: identity.identityId });
  return response.data;
}
